import { Grid } from '@mui/material'
import type { PRSheetEditorProps } from './types'
import { AboutMeSection } from './components/AboutMeSection'
import { PRSummarySection } from './components/PRSummarySection'
import { ExperiencesSection } from './components/ExperiencesSection'
import { PortfolioSection } from './components/PortfolioSection'
import { HighlightEpisodeSection } from './components/HighlightEpisodeSection'
import { EducationsSection } from './components/EducationsSection'
import { LinksSection } from './components/LinksSection'
import { SkillsEditor } from '../SkillsEditor'

export default function PRSheetEditor({
  data,
  onChange = () => {},
  onBlur = () => {},
  fixedSkillRatings,
  onFixedSkillRatingChange,
  onFixedSkillDescriptionChange,
  languageSkills,
  onLanguageSkillsChange,
  onLanguageSkillDelete,
}: PRSheetEditorProps) {
  const handleFieldChange = (field: keyof typeof data.prSheet, value: string) => {
    console.log('handleFieldChange called:', { field, value })
    const newData = {
      ...data,
      prSheet: {
        ...data.prSheet,
        [field]: value,
      },
    }
    console.log('New prSheet data:', newData.prSheet)
    onChange(newData)
  }

  const handleExperiencesChange = (newExperiences: typeof data.experiences) => {
    onChange({
      ...data,
      experiences: newExperiences,
    })
  }

  const handlePortfolioItemsChange = (newItems: typeof data.portfolioItems) => {
    onChange({
      ...data,
      portfolioItems: newItems,
    })
  }

  const handleHighlightEpisodesChange = (newEpisodes: typeof data.highlightEpisodes) => {
    onChange({
      ...data,
      highlightEpisodes: newEpisodes,
    })
  }

  const handleEducationsChange = (newEducations: typeof data.educations) => {
    onChange({
      ...data,
      educations: newEducations,
    })
  }

  const handleLinksChange = (newLinks: typeof data.links) => {
    onChange({
      ...data,
      links: newLinks,
    })
  }

  return (
    <Grid container spacing={3}>
      <Grid size={{ xs: 12 }}>
        {/* PDFと同じ順序で表示 */}

        {/* 1. About Me */}
        <AboutMeSection
          prSheet={data.prSheet}
          onChange={handleFieldChange}
          onBlur={onBlur}
          linkedEntityId={data.prSheet.Career__c}
        />

        {/* 9. 学歴 */}
        <EducationsSection
          prSheetId={data.prSheet.Id}
          educations={data.educations}
          onChange={handleEducationsChange}
          onBlur={onBlur}
        />

        {/* 2. PRサマリー */}
        <PRSummarySection prSheet={data.prSheet} onChange={handleFieldChange} onBlur={onBlur} />

        {/* 3. これまでの主な取り組み */}
        <ExperiencesSection
          prSheetId={data.prSheet.Id}
          experiences={data.experiences}
          onChange={handleExperiencesChange}
          onBlur={onBlur}
        />

        {/* 5. 制作ポートフォリオ */}
        <PortfolioSection
          prSheetId={data.prSheet.Id}
          portfolioItems={data.portfolioItems}
          onChange={handlePortfolioItemsChange}
          onBlur={onBlur}
        />

        {/* 6. 注力エピソード */}
        <HighlightEpisodeSection
          prSheetId={data.prSheet.Id}
          highlightEpisodes={data.highlightEpisodes}
          onChange={handleHighlightEpisodesChange}
          onBlur={onBlur}
        />

        {/* 4. スキル */}
        <SkillsEditor
          prSheetId={data.prSheet.Id}
          fixedSkillRatings={fixedSkillRatings}
          onFixedSkillRatingChange={onFixedSkillRatingChange}
          onFixedSkillDescriptionChange={onFixedSkillDescriptionChange}
          languageSkills={languageSkills}
          onLanguageSkillsChange={onLanguageSkillsChange}
          onLanguageSkillDelete={onLanguageSkillDelete}
        />

        {/* 10. 外部リンク */}
        <LinksSection prSheetId={data.prSheet.Id} links={data.links} onChange={handleLinksChange} onBlur={onBlur} />
      </Grid>
    </Grid>
  )
}
